import { render } from "./NavigationDashboard.vue?vue&type=template&id=0e8a1cbe&scoped=true"
import script from "./NavigationDashboard.vue?vue&type=script&lang=js"
export * from "./NavigationDashboard.vue?vue&type=script&lang=js"

import "./NavigationDashboard.vue?vue&type=style&index=0&id=0e8a1cbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8a1cbe"]])

export default __exports__